module.exports = __webpack_public_path__ + "img/heart_1_bj.8f88fa60.png";